<template>
  <div class="mainBox">
    <div class="w-12 foot_page">
      <div class="footer-l">
        <p>
          <span>公司地址：济南邦得人力资源有限公司（济南人才市场）</span>
        </p>
        <p>
          <span>公司地址：济南市经十路22399号</span>
          <!-- <span>邮编： 250022</span> -->
          <span>备案号：鲁ICP备17022975号-1</span>
        </p>
        <p>
          <span>电话：0531-87081655/87081633</span>
          <span>邮箱：jinanbangde2008@163.com</span>
          <span>传真：0531--87081707</span>
        </p>
      </div>
      <div class="footer-r">
        <img
          src="../../../assets/images/aboutus.png"
          style="height: 100%"
          alt=""
        />
      </div>
    </div>
    <div id="cnzz_box">

    </div>
  </div>
</template>

<script>
export default {
  name: "XWViewFooter",
  data() {
    return {
      count: 178334,
    };
  },
};
</script>

<style scoped>
.mainBox {
  height: 8rem;
  background-color: #f2f2f2;
  padding-top: 10px;
}

.foot_page {
  font-size: 12px;
  text-align: center;
  display: flex;
  align-items: center;
  height: 100%;
}

.footer-l {
  flex: 1;
  line-height: 2;
}

.footer-r {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/XWViewFooter/ViewFooter.vue